import { AlertTriangle } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { RecordStatusBadge } from './record-status-badge'
import type { RecordStatus } from '../api/records-api'

const KNOWN_STATUSES: RecordStatus[] = [
  'draft',
  'in_progress',
  'submitted_for_review',
  'under_review',
  'approved',
  'needs_revision',
]

interface ConflictDialogProps {
  open: boolean
  currentVersion: number
  currentStatus: string
  onReload: () => void
  onClose: () => void
}

export function ConflictDialog({
  open,
  currentVersion,
  currentStatus,
  onReload,
  onClose,
}: ConflictDialogProps) {
  const safeStatus: RecordStatus = KNOWN_STATUSES.includes(currentStatus as RecordStatus)
    ? (currentStatus as RecordStatus)
    : 'draft'

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-orange-400" />
            تعارض در ذخیره‌سازی
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            این سابقه توسط کاربر دیگری تغییر کرده است. نسخه فعلی روی سرور را مشاهده کنید.
          </p>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">نسخه {currentVersion} —</span>
            <RecordStatusBadge status={safeStatus} />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>انصراف</Button>
          <Button onClick={onReload}>بارگذاری مجدد</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
